import type { Track } from '@/types/tour'

type ProfileTrackCandidate = Pick<Track, 'clientId' | 'segments' | 'visible'>

export function trackHasProfileData(track: Pick<Track, 'segments'> | null | undefined): boolean {
  let pointCount = 0

  for (const segment of track?.segments ?? []) {
    pointCount += segment.points?.length ?? 0
    if (pointCount > 1) {
      return true
    }
  }

  return false
}

export function resolveTrackProfileTrack<T extends ProfileTrackCandidate>(
  tracks: readonly T[],
  preferredTrackClientId?: string | null,
): T | null {
  if (preferredTrackClientId) {
    const preferredTrack = tracks.find((track) => track.clientId === preferredTrackClientId) ?? null
    if (trackHasProfileData(preferredTrack)) {
      return preferredTrack
    }
  }

  return (
    tracks.find((track) => track.visible !== false && trackHasProfileData(track)) ??
    tracks.find((track) => trackHasProfileData(track)) ??
    null
  )
}
